module.exports = __webpack_public_path__ + "media/images/brand/150/MARQUESBRANDINGCO LOGO X-fefd93d5c71ca85bee21a5fb9ecf30e5.png";